import type { FlowRule } from "@/modules/flow";
import type { CustomDialogOptions } from "@/shared/components/dialog";

export function getFlowRuleDialogOptions(
  rule?: FlowRule | null,
): CustomDialogOptions {
  return {
    title: rule ? "编辑流程" : "创建流程",
    description: "设置条件和动作，系统会自动整理新收藏。",
    className:
      "h-[100dvh] max-h-[100dvh] max-w-none grid-rows-[auto_minmax(0,1fr)] gap-0 overflow-hidden rounded-none p-0 sm:h-auto sm:max-h-[90vh] sm:max-w-[720px] sm:rounded-xl [&>[data-slot=dialog-header]]:border-b-0 [&>[data-slot=dialog-header]]:px-6 [&>[data-slot=dialog-header]]:pt-5 [&>[data-slot=dialog-header]]:pr-14",
    closeOnOutside: false,
    closeOnEsc: true,
  };
}
